import { render } from "./FirstTimeConversation.vue?vue&type=template&id=ddf9c6a6&scoped=true"
import script from "./FirstTimeConversation.vue?vue&type=script&lang=js"
export * from "./FirstTimeConversation.vue?vue&type=script&lang=js"

import "./FirstTimeConversation.vue?vue&type=style&index=0&id=ddf9c6a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf9c6a6"]])

export default __exports__